<template>
  <div class="custom-legend">
    <div class="legend-circle" :style="{ backgroundColor: color }"></div>
    <span class="legend-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomLegend',
  props: {
    color: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.custom-legend {
  display: flex;
  align-items: center;
}
.custom-legend:not(:first-child) {
  margin-left: 10px;
}

.legend-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.legend-text {
  font-size: 14px;
  color: #333;
}
</style>
